import React, { useEffect, useState } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Button, Select, message, Typography, Tag } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import LoaderTsx from "../Loader.tsx";
import { getBookingRenewalForms, sendTenantInvite, updateBookingStatus, getRenewalPendingReq } from "./ducks/actions";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../utils/axiosInceptor";
import { baseContractService } from "../../../configs/constants";
import { getBookingUnitList } from "../Properties/PropertyDetail/ducks/actions";
import { Popup, PopupConfirm } from "../../atoms/Popup";
import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterBooking } from "../App/SearchFilters/ducks/actions";
import Title from "antd/es/typography/Title";
import BookingRenewalRequests from "./BookingRenewalRequests/BookingRenewalRequests";
import { clearBookingForm, emptyCreateBooking } from "../BookingForm/ducks/actions";
import { useBookingRenewalsSearch } from "./hooks";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { renewalCol, renewalColumn } from "./renewalCol";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { getGridSettings } from "../../../utils/globalService";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";
import { resetGridSettings } from "../../libs/constants";
import { useGridReset } from "../../../hooks/useGridReset";

const gridProps = {
  resizable: true,
};

const dropDown = [
  { id: 2, name: "Edit", status: "" },
  { id: 3, name: "Send To Tenant", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];

const dropDownRenewal = [
  { id: 2, name: "Edit", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];

const dropDown1 = [{ id: 2, name: "Edit", status: "" }];
const dropDown2 = [{ id: 2, name: "View Confirmed Form", status: "" }];
const dropDown3 = [{ id: 4, name: "View Approved Form", status: "" }];

const limit = 50;

const BookingRenewalListing = (props) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState(false);
  const listBookingRenewal = useSelector((state: any) => state.bookingRenewals.bookingRenewalList);
  const units = useSelector((state: any) => state.propertyDetails.bookingUnits);
  const pendingRenewalRequests = useSelector((state: any) => state.bookingRenewals.pendingRenewalRequests);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [updateValue, setUpdateValue] = useState({});
  const [visible, setVisible] = useState({ status: false, index: 0 });
  const filter = useSelector((state: any) => state.filters.bookingsData);
  const [selectedSearchBy, setSelectedSearchBy] = useState(Object.keys(filter)[0] ?? "unitCode");
  const [searchValue, setSearchValue] = useState(filter[Object.keys(filter)[0]] || state?.unitId || "");
  const { searchHistory, addToSearchHistory } = useSearchHistory(setFilterBooking);
  const { selectOptions, handleSearch, handleChangeSearchBy } = useBookingRenewalsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });
  const [renewalColumns, setRenewalColumns] = useState(() => [...renewalCol]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const organization = useSelector((state: any) => state.tickets.orgData);
  const { resetGrid, setGridReset } = useGridReset();
  useEffect(() => {
    if (selectedProperty?.propertyId) dispatch(getBookingUnitList(selectedProperty?.propertyId));
  }, [selectedProperty]);

  useEffect(() => {
    dispatch(clearBookingForm());
    dispatch(getRenewalPendingReq());
  }, []);

  useEffect(() => {
    const buildLeaseColumnsWithKyc = (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name)
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 47 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...renewalCol, ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setRenewalColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };

    init();
  }, [organization, resetGrid]);

  const getGridConfig = async (columns) => {
    let result = await getGridSettings("renewals", columns, resetGrid);
    if (result?.length) {
      setRenewalColumns(result);
      setGridReset(false);
    }
  };

  function handlePropertyChange(property, label) {
    if (label === "property" && property?.value) {
      setSelectedProperty({
        propertyId: property?.value,
        property_name: property?.label,
      });
      setUpdateValue({ label: "unit", value: null });
      setSelectedUnit({});
    } else if (label === "unit" && property?.value != null) {
      setSelectedUnit(units[property?.value]);
    }
  }

  const sendToTenant = async (email, leaseId) => {
    if (email && leaseId) {
      let payload = [
        {
          email: email,
          usertype: "tenant",
          leaseId: leaseId,
          inviteAll: false,
        },
      ];
      let successMessage = "Invite sent to tenant successfully";
      const status = await sendTenantInvite(payload, successMessage);
      if (status === 200) {
        message.success(successMessage);
        const res = await updateBookingStatus(leaseId, {
          status: "tenant_invitation_sent",
        });
        if (res === 200) {
          message.success(successMessage);
          setIsLoading(true);
          dispatch(getBookingRenewalForms(limit, currentPage, "", "", "", "", "", setIsLoading));
        }
      }
    } else {
      message.error("No email id present");
    }
  };

  const BookingForm = () => {
    dispatch(emptyCreateBooking());

    if (selectedUnit?.unitId && selectedProperty)
      navigate("/newbookingform", {
        state: {
          selectedUnit: selectedUnit,
          selectedProperty: selectedProperty,
        },
      });
    else message.error("Please select property and unit");
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
    setIsLoading(true);

    dispatch(
      getBookingRenewalForms(limit, pg, searchValue, selectedSearchBy, null, null, null, setIsLoading, renewalColumns)
    );
  };

  useEffect(() => {
    setCurrentPage(1);
    addToSearchHistory(selectedSearchBy, searchValue); //adding search history and filter store
    setIsLoading(true);
    dispatch(
      getBookingRenewalForms(
        limit,
        1,
        searchValue,
        selectedSearchBy,
        exportData,
        listBookingRenewal?.totalCount,
        setExportData,
        setIsLoading,
        renewalColumns
      )
    );
  }, [searchValue, exportData]);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchByOptions.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Renewal Booking Request(s)
        </Title>
      ),
      content: (
        <BookingRenewalRequests
          showAll={true}
          getAllBookRequests={pendingRenewalRequests}
          getAllLeaseRequests={{ data: [] }}
          getAllPlanRequests={{ data: [] }}
        />
      ),
      width: 1650,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible.status,
    title: popup[visible.index].title,
    content: popup[visible.index].content,
    width: popup[visible.index].width,
    onCancel: () => {
      setVisible({ status: false, index: 0 });
    },
  };

  const MoreAction = (row) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { Text } = Typography;

    const onChangeHandler = async (e) => {
      if (e === "Cancel") {
        onStatus(row.data.leaseId);
      } else if (e === "Download booking form") {
      } else if (e === "Send To Tenant") {
        if (row.data?.tenantDetails?.email && row.data?.leaseId)
          sendToTenant(row.data.tenantDetails.email, row.data.leaseId);
      } else if (e === "View Confirmed Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "View Approved Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Edit") {
        if (row?.data?.leaseStatus === "draft") navigate(`/newbookingform/${row.data.leaseId}`);
        else navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Send for tenant's signature") {
        try {
          let body = {
            leadId: row.data.id,
          };
          await axios.post(`${baseContractService}/booking-form-send-to-prospect`, body);
          message.success("Successfully Sent");
        } catch (e) {
          const { response } = e;
          message.error(response?.data?.message);
        }
      }
    };

    const onStatus = (leaseId) => {
      PopupConfirm({
        title: `Are you sure you want to cancel`,
        onOk: () => onCancelBookingForm(leaseId),
        okText: "Yes",
      });
    };

    const onCancelBookingForm = async (leaseId) => {
      const res = await updateBookingStatus(leaseId, {
        status: "booking_reject",
      });
      if (res === 200) {
        message.success("Booking has been cancelled");
        setIsLoading(true);
        dispatch(getBookingRenewalForms(limit, currentPage, "", "", "", "", "", setIsLoading));
      }
    };

    return (
      <Select
        onChange={onChangeHandler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          {row.data.leaseStatus === "booking_created" &&
            (row.data.leaseType == "renewal"
              ? dropDownRenewal.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value.name}>
                      <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                ))
              : dropDown.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value.name}>
                      <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                )))}
          {row.data.leaseStatus !== "booking_created" &&
            row.data.leaseStatus !== "booking_confirmed" &&
            row.data.leaseStatus !== "booking_approved" &&
            dropDown1.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_confirmed" &&
            dropDown2.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_approved" &&
            dropDown3.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
        </>
      </Select>
    );
  };

  //  for export data and send in email
  const exportAction = () => {
    setExportData(true);
  };

  return (
    <DashboardLayout>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <SectionHeaderV2
                heading="Renewals in Progress"
                total={listBookingRenewal?.totalCount || 0}
                downloadAction={exportAction}
                propertyAdminOptions={true}
                headTopLeftText={
                  pendingRenewalRequests?.totalCount ? (
                    <Button danger type="text" onClick={() => setVisible({ status: true, index: 0 })}>
                      <InfoCircleOutlined /> {pendingRenewalRequests?.totalCount} pending requests
                    </Button>
                  ) : null
                }
                onSearch={handleSearch}
                onChangeSearchBy={handleChangeSearchBy}
                defaultSearch={searchValue}
                searchByOptions={searchByOptions}
                selectOptions={selectOptions}
                justifiedItems={true}
                justifyEnd={true}
                handleView={handlePropertyChange}
                updateValue={updateValue}
                viewOptionAction={BookingForm}
              />
            </Col>
            <Col span={23}>
              <Pagination
                className="ag-property-text-pagination"
                total={listBookingRenewal?.totalCount || 0}
                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} bookings`}
                defaultPageSize={50}
                defaultCurrent={1}
                showSizeChanger={false}
                current={currentPage}
                onChange={(e) => handlePagination(e)}
              />
            </Col>
            <Col span={1}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <DragAndDropList
                  columns={renewalColumns}
                  setModifiedColumns={setRenewalColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="renewals"
                  setGridReset={setGridReset}
                />
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="end">
                <Col span={24}>
                  <Card bordered={false} className="ag-nospace-body">
                    {isLoading ? (
                      <LoaderTsx />
                    ) : (
                      <Grid
                        refCol="status"
                        data={listBookingRenewal?.data ?? []}
                        columns={renewalColumn(renewalColumns, MoreAction, props)}
                        autoSizeColumns={true}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Bookings"
                        fullPage={true}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Popup destroyOnClose={true} {...popupProps} />
    </DashboardLayout>
  );
};

export default BookingRenewalListing;
